import {AuthorizationApi} from "../api";
import {IObservableValue, observable} from "mobx"
import {MAIN_PAGE} from "../enums";
import {MAuthorization} from "@elte/translate-backend/interface/authorization";

export type TUser = {
    modules: MAIN_PAGE[]
} & MAuthorization.TResponseLogin;

export class AuthorizationModel {
    logout() {
        return this.api.logout()
            .finally(() => {
                this.user.set(null);
            });
    }

    protected readonly api: AuthorizationApi;

    user: IObservableValue<TUser> = observable.box(null, {deep: false});

    constructor() {
        this.api = new AuthorizationApi();
    }

    continueAuth(response: MAuthorization.TResponseLogin) {
        if (response.user.privilege == 'admin') {
            this.user.set({
                accessToken: response.accessToken,
                user: response.user,
                authentication: response.authentication,
                modules: [MAIN_PAGE.TRANSLATE, MAIN_PAGE.CONFIRM_TRANSLATE, MAIN_PAGE.SELF_CONFIG, MAIN_PAGE.USER_CONFIG, MAIN_PAGE.LOGOUT]
            });
            return this.user.get();
        }
        else if (response.user.privilege == 'user') {
            this.user.set({
                accessToken: response.accessToken,
                user: response.user,
                authentication: response.authentication,
                modules: response.user.approval == true ? [MAIN_PAGE.TRANSLATE,  MAIN_PAGE.CONFIRM_TRANSLATE, MAIN_PAGE.LOGOUT] : [MAIN_PAGE.TRANSLATE, MAIN_PAGE.LOGOUT]
            });
            return this.user.get();
        }
        throw "bad login";
    }

    public login(name: string, password: string): Promise<TUser> {
        return this.api
            .login({
                email: name,
                password,
                strategy: "local"
            })
            .then(response => {

                return this.continueAuth(response);

            }, (err => {
                this.user.set(null);
                return Promise.reject(err);
            }))
    }

    public relogin(): Promise<TUser> {

        if (this.user.get() !== null) {
            return Promise.resolve(null)
        }

        return this.api
            .relogin()
            .then((res) => {
                return this.continueAuth(res);
            }, err => {
                window.sessionStorage.removeItem("apiToken");
                this.user.set(null);
                return null
            })
    }

}
